/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CountryViewModel } from "../types/CountryViewModel.ts";

export const countryViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  code: z.string().nullish(),
  name: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<CountryViewModel>;
